import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLockOff = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.99935 2.49967C8.1584 2.49967 6.66602 3.99206 6.66602 5.83301V8.33301H15.8327C17.2134 8.33301 18.3327 9.45229 18.3327 10.833V16.6663C18.3327 18.0471 17.2134 19.1663 15.8327 19.1663H4.16602C2.7853 19.1663 1.66602 18.0471 1.66602 16.6663V10.833C1.66602 9.45229 2.7853 8.33301 4.16602 8.33301H4.99935V5.83301C4.99935 3.07158 7.23793 0.833008 9.99935 0.833008C12.1329 0.833008 13.9544 2.16939 14.6724 4.05077C14.83 4.4637 14.5563 4.89434 14.1278 5.00262C13.6663 5.11923 13.2098 4.81413 13.0028 4.38549C12.464 3.26955 11.3216 2.49967 9.99935 2.49967ZM3.33268 10.833C3.33268 10.3728 3.70578 9.99967 4.16602 9.99967H15.8327C16.2929 9.99967 16.666 10.3728 16.666 10.833V16.6663C16.666 17.1266 16.2929 17.4997 15.8327 17.4997H4.16602C3.70578 17.4997 3.33268 17.1266 3.33268 16.6663V10.833Z",
		fill: "white"
	})
});
export default SvgLockOff;
